import {OrganizationField} from "./index";

export enum CompanyCardField {
    ID = "id",
    CARD_ID = "cardId",
    CARD_READER_IP = "cardReaderIP",
    CARD_READER_SLOT = "cardReaderDrawerSlot",
    CARD_READER_DRAWER = "cardReaderDrawer",
    CARD_SERVER_ID = "cardServerId",
    CARD_SERVER = "cardServer",
    COMMENT = "comment",
    CREATED_AT = "createdAt",
    DIVISION = "division",
    ORGANIZATION_ID = "organizationId",
    ORGANIZATION = "organization",
    UPDATED_AT = "updatedAt",
    VALID_UNTIL = "validUntil",
    ORGANIZATION_NAME = "organizationName",
}

export interface CompanyCard {
    [CompanyCardField.ID]: number;
    [CompanyCardField.CARD_ID]: number;
}

export enum CompanyCardServerField {
    ID = "id",
    NAME = "name",
    IP_ADDRESS = "ipAddress",
}

export interface CompanyCardServer {
    [CompanyCardServerField.ID]: number;
    [CompanyCardServerField.NAME]: string;
    [CompanyCardServerField.IP_ADDRESS]: string;
}

export interface CardOrganization {
    [OrganizationField.MAIN_DKV_CUSTOMER_NUMBER]: string;
    [OrganizationField.NAME]: string;
    [OrganizationField.ID]: number;
}

export interface CompanyCardDetail extends CompanyCard {
    [CompanyCardField.CARD_READER_IP]?: string;
    [CompanyCardField.CARD_READER_SLOT]: number;
    [CompanyCardField.CARD_READER_DRAWER]: number;
    [CompanyCardField.CARD_SERVER_ID]: number;
    [CompanyCardField.CARD_SERVER]: CompanyCardServer;
    [CompanyCardField.COMMENT]: string;
    [CompanyCardField.CREATED_AT]: string;
    [CompanyCardField.DIVISION]: string;
    [CompanyCardField.ORGANIZATION]: CardOrganization;
    [OrganizationField.NAME]: string;
    [OrganizationField.MAIN_DKV_CUSTOMER_NUMBER]: string;
    [CompanyCardField.ORGANIZATION_ID]: number;
    [CompanyCardField.UPDATED_AT]: string;
    [CompanyCardField.VALID_UNTIL]: string;
    [CompanyCardField.CARD_READER_DRAWER]: number;
    [CompanyCardField.ORGANIZATION_NAME]: number;
}
